import Vue from 'vue';
import Vuex from 'vuex';
import OfflineStorage from '../offlineStorage';
import router from '../router';
import auth from '../utils/auth';
import TdmWebApi from '../api/webapi';
import graphApi from '../api/graphApi';

Vue.use(Vuex)
Vue.config.devtools = true

export default new Vuex.Store({
  state: {
    isAuthenticated: false,
    isOnline: navigator.onLine,
    settings: {},
    tabletInfo: null,
    userProfile: null
  },
  mutations: {
    REPLACE_STATE_PROP: (state, payload) => {
      state[payload.property] = payload.data;
    }
  },
  actions: {
    async initializeStore(context) {
      // Get Settings
      let settings = await OfflineStorage.getItem("settings");
      if (settings == null) {
        settings = {
          isDarkMode: false,
          farmLineMg: []
        };
      }
      context.commit("REPLACE_STATE_PROP", { property: 'settings', data: settings });

      // Get User Profile
      let userProfile = await OfflineStorage.getItem('userProfile');
      if (!context.state.isOnline && userProfile != null) {
        context.commit("REPLACE_STATE_PROP", { property: "userProfile", data: userProfile });

        if (router.currentRoute && router.currentRoute.path !== '/') {
          router.push({ path: '/' });
        }
        return;
      }

      const response = await auth.ssoSilent();
      if (response) {
        context.commit("REPLACE_STATE_PROP", { property: "isAuthenticated", data: true });
        await setUserProfile(context);
        await setUserRoles(context);
      }
    },
    async storeSignIn(context) {
      await auth.signIn();

      context.commit("REPLACE_STATE_PROP", { property: "isAuthenticated", data: true });

      await setUserProfile(context);
      await setUserRoles(context);

      if (router.currentRoute.path !== '/') {
        router.push({ path: '/' });
      }
    },
    async storeSignOut(context) {
      auth.signOut();

      context.commit("REPLACE_STATE_PROP", { property: "userProfile", data: null });
      context.commit("REPLACE_STATE_PROP", { property: "isAuthenticated", data: false });

      await OfflineStorage.setItem('userProfile', null);

      if (router.currentRoute.path !== '/signin') {
        router.push({ path: '/signin' });
      }
    },
    async setOnlineStatusInStore(context, isOnline) { 
      context.commit('REPLACE_STATE_PROP', { property: 'isOnline', data: isOnline });
      if (isOnline && 
        !context.state.isAuthenticated) {
          await auth.ssoSilent(context);
      }
    },
    updateSettingsInStore(context, settings) { 
      context.commit('REPLACE_STATE_PROP', { property: 'settings', data: settings });
      OfflineStorage.setItem('settings', settings);
    },
    async initializeTabletInfo(context) {
      let tabletInfo = await TdmWebApi.getTabletList();
      context.commit("REPLACE_STATE_PROP", { property: 'tabletInfo', data: tabletInfo });
    }
  }
})

async function setUserProfile(context) {
  const userProfile = await graphApi.getUserProfile();
  if (userProfile) {
    context.commit("REPLACE_STATE_PROP", { property: "userProfile", data: userProfile });
    await OfflineStorage.setItem('userProfile', userProfile);
  } else {
    context.commit("REPLACE_STATE_PROP", { property: "userProfile", data: null });
    await OfflineStorage.setItem('userProfile', null);
  }
}

async function setUserRoles(context) {
  let assignments = await graphApi.getAppRoleAssignments();
  let userRoles = assignments.value;
  if (userRoles) {
    context.commit("REPLACE_STATE_PROP", { property: "userRoles", data: userRoles });
    await OfflineStorage.setItem('userRoles', userRoles);
  } else {
    context.commit("REPLACE_STATE_PROP", { property: "userRoles", data: null });
    await OfflineStorage.setItem('userRoles', null);
  }
}